"use client";

import { SidebarComponent } from "./sidebar.component";
import { MobileSidebarComponent } from "./mobile.sidebar.component";

/**
 * Mount both nav shells and toggle with CSS at 1200px (same breakpoint as the old
 * useScreenSize check). Swapping only one component in JS changed the hook tree
 * between renders and caused "Rendered more hooks than during the previous render".
 */
export const NavComponent = () => {
  return (
    <>
      <div className="hidden min-[1200px]:block">
        <SidebarComponent />
      </div>
      <div className="block min-[1200px]:hidden">
        <MobileSidebarComponent />
      </div>
    </>
  );
};
